import { render, staticRenderFns } from "./AppInputFile.vue?vue&type=template&id=2c0b1c12&scoped=true"
import script from "./AppInputFile.vue?vue&type=script&lang=js"
export * from "./AppInputFile.vue?vue&type=script&lang=js"
import style0 from "./AppInputFile.vue?vue&type=style&index=0&id=2c0b1c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b1c12",
  null
  
)

export default component.exports